var map = {
	"./task1.svg": "469d",
	"./task10.svg": "87c5",
	"./task11.svg": "ded0",
	"./task12.svg": "6dad",
	"./task13.svg": "2610",
	"./task14.svg": "a5d1",
	"./task15.svg": "4864",
	"./task16.svg": "4ab8",
	"./task17.svg": "062f",
	"./task2.svg": "9697",
	"./task3.svg": "23c6b",
	"./task4.svg": "7cf8",
	"./task5.svg": "bb84",
	"./task6.svg": "d72e",
	"./task7.svg": "f35f",
	"./task8.svg": "1067",
	"./task9.svg": "b9de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1510";